// src/services/clientService.js
import axios from 'axios';

const GET_CLIENT_API_URL = 'https://wiiz4u3ne0.execute-api.ap-southeast-1.amazonaws.com/'; // Replace with your actual API Gateway URL
const POST_CLIENT_API_URL = 'https://q04nsigh9h.execute-api.ap-southeast-1.amazonaws.com/'; // Replace with your actual API Gateway URL
const POST_CLIENT_QUEUE_API_URL = 'https://wxm8p9z2lc.execute-api.ap-southeast-1.amazonaws.com/'; // Replace with your actual API Gateway URL

// Fetch the list of clients from AWS API Gateway
export const getClients = async () => {
  try {
    const response = await axios.get(`${GET_CLIENT_API_URL}/prod/getJodyClientContactEmails`);
    return response.data;
  } catch (error) {
    console.error("Error fetching clients:", error);
    throw error; // Re-throw the error for handling in the component
  }
};

export const sendEmail = async (emailPayload) => {
    try {
      const response = await axios.post(`${POST_CLIENT_API_URL}/prod/postJodyClientContactEmails`, emailPayload);
      return response.data;
    } catch (error) {
      console.error("Error sending email:", error);
      throw error;
    }
  };

  export const sendEmailQueue = async (emailPayload) => {
    try {
      const response = await axios.post(`${POST_CLIENT_QUEUE_API_URL}/prod/PostJodyClientContactEmailsQueue`, emailPayload);
      return response.data;
    } catch (error) {
      console.error("Error sending email:", error);
      throw error;
    }
  };
  
  